module.exports = __webpack_public_path__ + "static/media/Guccish.7856209f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/_old/Guccish.jpg
// module id = 356
// module chunks = 0